module.exports = __webpack_public_path__ + "img/pirl.874c0c0d.svg";